export const FREQUENCIES = {
  INSTANTLY: 'INSTANTLY',
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
  NEVER: 'NEVER'
};

export const FREQUENCY_ORIGINS = {
  PROJECT: 'PROJECT',
  USER: 'USER',
  CHANGES: 'CHANGES'
};

export const DEFAULT_SETTING_TYPE = 'default';
